module.exports = __webpack_public_path__ + "static/group4_2-a9d51856fd7abbc0d94679e1193cfb42.webp";